import { BaseLogBloc } from "./bloc.base";

export class BoxLogBloc extends BaseLogBloc {

}